module.exports = __webpack_public_path__ + "img/recent-work-05.92ff1aa7.jpg";